
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.179 5.414l-.357-.258L12 .923l-4.252 3.09-1.57 1.143-5.825 4.23 2.225 6.848 2.225 6.843H19.197l2.225-6.843 2.225-6.847-5.468-3.973zm-.943.554l.943.684 4.093 2.973-4.093.745-4.96.901-1.053-8.989 5.07 3.686zm-10.485 0l.997-.726 4.103-2.98-1.188 9.038-2.915-.557L1.754 9.6 6.75 5.968zm-3.243 9.98l-1.99-6.135 6.23 2.798 2.138.958-2.139 3.954-2.326 4.3-1.913-5.876zm14.67 6.162H5.613l2.136-2.305 4.28-4.606 6.15 6.755.14.156h-.14zm2.302-6.163l-1.948 5.984-.353-.659-4.097-7.588 4.097-1.862L22.45 9.88l-1.97 6.067z","fill":"#D2AD75"}})])
          )
        }
      }
    